@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.config

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.config.SipExtensionDto

object GetCallConfigEndpoint : EndPoint<GetCallConfigEndpoint.Request, GetCallConfigEndpoint.Response>() {
    class Request()
    class Response(
        val sipExtensionDto: SipExtensionDto?,
        val phoneNumber: String?
    )
}